// extracted by mini-css-extract-plugin
export default {"title":"quick-charge-method-modal_title__gUVid","options":"quick-charge-method-modal_options__qg0+f","option":"quick-charge-method-modal_option__2BW+8"};